import React from 'react';

import {AttunementIcon, ConcentrationIcon, RitualIcon} from '../../../../components/spell-icons';
import {cls} from '../../../../components/utils';
import {useCharacter} from '../character-context';

import css from './sheet.module.css';

type SpellTitleIconsProps = {
	spellId: string;
	/** заклинание накладывается как ритуал: иначе иконка ритуала не показывается */
	asRitual?: boolean;
};

export const SpellTitleIcons: React.FC<SpellTitleIconsProps> = ({spellId, asRitual}) => {
	const {catalog} = useCharacter();
	const data = catalog.getSpell(spellId);
	if (!data || (!data.concentration && !asRitual)) return null;
	return (
		<span className={css.titleIcons}>
			{data.concentration && (
				<span title="Концентрация">
					<ConcentrationIcon width={16} height={16} role="img" aria-label="Концентрация" />
				</span>
			)}
			{asRitual && (
				<span title="Ритуал">
					<RitualIcon width={16} height={16} role="img" aria-label="Ритуал" />
				</span>
			)}
		</span>
	);
};

type AttunementMarkProps = {
	/** персонаж настроен на предмет: иначе иконка бледная */
	attuned: boolean;
};

export const AttunementMark: React.FC<AttunementMarkProps> = ({attuned}) => {
	const label = attuned ? 'Настроен' : 'Требует настройки';
	return (
		<span className={cls(css.titleIcons, !attuned && css.inactiveIcon)} title={label}>
			<AttunementIcon width={16} height={16} role="img" aria-label={label} />
		</span>
	);
};
